import reduxApi, {transformers} from 'redux-api';
import customFetch from 'api/axios';
import CONFIG from 'base/constants/config';

const rest = reduxApi({
  list: {
    url: 'categories',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    },
    postfetch: [
      ({data, dispatch}) => {
        dispatch({
          type: 'CATEGORIES_TO_TREE',
          categories: data.data
        });
      },
      ({data, dispatch}) => {
        dispatch({
          type: 'ARRAY_CATEGORIES_TO_HASH',
          categories: data.data
        });
      }
    ]
  },
  add: {
    url: 'categories',
    options: {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  uploadLogo: {
    url: 'categories/uploadLogo',
    options: {
      method: "POST"
    }
  },
  update: {
    url: 'categories/:id',
    options: {
      method: "PATCH",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  delete: {
    url: 'categories/:id',
    options: {
      method: "DELETE",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  category: {
    url: 'categories/:id',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  children: {
    url: 'categories/:id/children',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  listProducts: {
    url: 'categories/:id/products',
    options:(url, params, getState) => {
      return {
        method: "GET",
        params
      };
    }
  },
  countProduct: {
    url: 'categories/:id/products/count',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  categoryDemand: {
    url: 'categories/countDemands',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  countDemand: {
    url: 'categories/:id/demands/count',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  demands: {
    url: 'categories/:id/demands',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  listFixProducts: {
    url: 'categories/:id/_products',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  countFixProduct: {
    url: 'categories/:id/_products/count',
    options: {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  }
}).use('fetch', customFetch)
  .use("rootUrl", CONFIG.API_URL);

export default rest;



// WEBPACK FOOTER //
// ./api/categories.js